window.Studio407 = window.Studio407 || {};

(function(Studio) {
  'use strict';

  Studio.state = window.studioState = window.studioState || {};
  Studio.state.setSize = Studio.state.setSize || 6;
  Studio.state.slots = [];
  Studio.state.activeSlot = null;

  Studio.uploadLiftField = null;

  window.addEventListener('upload:ready', function(event) {
    if (!event.detail) return;

    Studio.uploadLiftField = event.detail;
    window.uploadLiftField407 = event.detail;

    console.log('Upload-Lift connected to 407 Studio');
  });

  Studio.waitForUploadLift = function(timeoutMs = 10000) {
    return new Promise(function(resolve, reject) {
      const startedAt = Date.now();

      function checkField() {
        const field = Studio.uploadLiftField || window.uploadLiftField407;

        if (field && typeof field.uploadFile === 'function') {
          resolve(field);
          return;
        }

        if (Date.now() - startedAt >= timeoutMs) {
          reject(
            new Error(
              'Upload-Lift did not become ready within the expected time.'
            )
          );
          return;
        }

        window.setTimeout(checkField, 150);
      }

      checkField();
    });
  };

  Studio.getSelectedSetButton = function() {
    return document.querySelector('.panel-407__set.is-selected');
  };

  Studio.getSelectedSetSize = function() {
    const selectedSet = Studio.getSelectedSetButton();
    const text = selectedSet
      ? selectedSet.dataset.setSize || selectedSet.textContent || ''
      : '';

    const match = text.match(/\d+/);

    return match ? parseInt(match[0], 10) : 6;
  };

  Studio.getSelectedVariantId = function() {
    const selectedSet = Studio.getSelectedSetButton();

    if (selectedSet && selectedSet.dataset.variantId) {
      return selectedSet.dataset.variantId;
    }

    const variantInput = document.querySelector(
      'form[action*="/cart/add"] input[name="id"]'
    );

    return variantInput ? variantInput.value : null;
  };

  Studio.showStep = function(stepName) {
    document.querySelectorAll('[data-studio-step]').forEach(function(step) {
      step.hidden = step.dataset.studioStep !== stepName;
    });

    const progressMap = {
      upload: 'upload',
      gallery: 'edit',
      editor: 'edit',
      preview: 'preview'
    };

    document.querySelectorAll('[data-studio-progress]').forEach(function(item) {
      item.classList.toggle(
        'is-active',
        item.dataset.studioProgress === progressMap[stepName]
      );
    });
  };

  Studio.revokePreviewUrl = function(url) {
    if (typeof url === 'string' && url.startsWith('blob:')) {
      URL.revokeObjectURL(url);
    }
  };

  Studio.revokeAllPreviewUrls = function() {
    if (!Array.isArray(Studio.state.slots)) return;

    Studio.state.slots.forEach(function(slot) {
      Studio.revokePreviewUrl(slot.image);
    });
  };

  Studio.initializeSlots = function() {
    Studio.revokeAllPreviewUrls();

    Studio.state.slots = [];

    for (let i = 0; i < Studio.state.setSize; i += 1) {
      Studio.state.slots.push({
        id: i,
        originalFile: null,
        originalImage: null,
        image: null,
        finalFile: null,
        edited: false
      });
    }

    Studio.state.activeSlot = null;
  };

  Studio.readFileAsDataURL = function(file) {
    return new Promise(function(resolve, reject) {
      const reader = new FileReader();

      reader.onload = function(event) {
        resolve(event.target.result);
      };

      reader.onerror = function() {
        reject(new Error(`Could not read ${file.name}.`));
      };

      reader.readAsDataURL(file);
    });
  };

  Studio.dataUrlToImage = function(dataUrl) {
    return new Promise(function(resolve, reject) {
      const image = new Image();

      image.onload = function() {
        resolve(image);
      };

      image.onerror = function() {
        reject(new Error('Could not prepare the image for upload.'));
      };

      image.src = dataUrl;
    });
  };

  Studio.createOptimizedOriginalFile = async function(slot, index) {
    if (!slot || !slot.originalImage) {
      throw new Error(`Photo ${index + 1} is missing.`);
    }

    const image = await Studio.dataUrlToImage(slot.originalImage);
    const maxDimension = 2400;
    const scale = Math.min(
      1,
      maxDimension / Math.max(image.naturalWidth, image.naturalHeight)
    );

    const width = Math.max(1, Math.round(image.naturalWidth * scale));
    const height = Math.max(1, Math.round(image.naturalHeight * scale));

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;

    const context = canvas.getContext('2d');

    if (!context) {
      throw new Error('Could not prepare the original photo.');
    }

    context.imageSmoothingEnabled = true;
    context.imageSmoothingQuality = 'high';
    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, width, height);
    context.drawImage(image, 0, 0, width, height);

    const blob = await new Promise(function(resolve, reject) {
      canvas.toBlob(
        function(result) {
          if (result) {
            resolve(result);
          } else {
            reject(new Error('Could not optimize the original photo.'));
          }
        },
        'image/jpeg',
        0.98
      );
    });

    return new File([blob], `407-original-${index + 1}.jpg`, {
      type: 'image/jpeg',
      lastModified: Date.now()
    });
  };

  Studio.getFileForUpload = async function(slot, index) {
    if (slot.finalFile) {
      return slot.finalFile;
    }

    if (!slot.originalFile) {
      throw new Error(`Photo ${index + 1} is missing.`);
    }

    const allowedTypes = ['image/jpeg', 'image/png'];
    const uploadLimit = 9.5 * 1024 * 1024;

    if (
      allowedTypes.includes(slot.originalFile.type) &&
      slot.originalFile.size <= uploadLimit
    ) {
      return slot.originalFile;
    }

    return Studio.createOptimizedOriginalFile(slot, index);
  };
})(window.Studio407);
